import { createBaseLogger } from '../baseLogger';
import { createConsoleTransport } from './consoleTransport/consoleTransport';
import {} from './systemLogger.types';
import { withLogLevelFilter } from './withLogLevelFilter';
const transports = [withLogLevelFilter(createConsoleTransport(), 'INFO')];
export const systemLogger = createBaseLogger({
    transports,
});
